import { Spinner, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getOutletInformation } from "../../actions/autocompleteActions";
import { getCurrentOutlet, getOutlates, getStatusDeliveryStore } from "../../actions/productActions";
import { useEffect, useState } from "react";
import { getSelectedOutlet, checkIfRestDay } from "./outletFunctions";
import { RiMapPin2Line, RiTimeLine, RiPhoneLine, RiStore2Line } from "react-icons/ri";
import "../../assets/css/form.css"
import PopUp from "../Modals/Popup";
import "./Sidebar.css";
import "./OutletInfo.css";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";

const OutletInfo = (props) => {

  const [numberOfOutlets, setNumberOfOutlets] = useState(0)
  const [statusOutlet, setStatusOutlet] = useState(false)
  const [statusPopUp, setStatusPopUp] = useState(false);

  const defaultData = {
    id: 0,
    name: ""
  }
  const [currentOutlet, selectOutlet] = useState({ //CURRENT OUTLET DATA USED TO KEEP TRACK WHEN USER CLICKS ON OUTLET
    ...defaultData
  });

  useEffect(() => {
    if (currentOutlet) {
      props.getCurrentOutlet(currentOutlet);
    }
  }, [currentOutlet]);

  // const getSelectedOutlet = (id) => { //RETURN DELIVERY CHARGE FOR SPECIFIC OUTLET VIA ID
  //   for (let i = 0; i < props?.postal?.outlet?.data.length; ++i){
  //     if (id === props?.postal?.outlet?.data[i].id) {
  //       return props?.postal?.outlet?.data[i].charges
  //     }
  //   }
  // }

  const changeDeliveryCharge = (outlet) => { //UPDATE DELIVERY FEES AND RESPECTIVE OUTLET INFORMATION

    if (outlet) {
      props.setDeliveryInformation({ //SET OUTLET INFORMATION USING THE SET STATE FUNCTION(SETOUTLET) FROM RIGHT-SIDEBAR.JS SO IT RENDERS THE NEW VALUE
        ...props.deliveryInformation,
        deliveryOutName: outlet.name,
        deliveryOutLat: outlet.lat,
        deliveryOutLong: outlet.lng,
        deliveryOutAddress: outlet.address,
        deliveryOutId: outlet.id,
        deliveryCharge: outlet.charges?.totalFee,
        deliveryCurrency: outlet.charges?.totalFeeCurrency,
        deliveryQuotationId: outlet.charges?.data?.quotationId,
        deliveryScheduleAt: outlet.charges?.data?.scheduleAt,
        deliveryExpiresAt: outlet.charges?.data?.expiresAt,
        deliveryStopIdOne: outlet.charges?.data?.stops[0].stopId,
        deliveryStopIdTwo: outlet.charges?.data?.stops[1].stopId
      })
    }
  }

  useEffect(() => {
    setStatusOutlet(props.outlet_status.result);
    if (props.outlet_status.result) {
      props.closeOutlet()
    } else {
      if (props.outlet_status.result != undefined && !props.postal?.loading) {
        setStatusPopUp(true);
      }
    }
  }, [props.outlet_status])

  const hideStatusOutletModal = () => {
    console.log(statusPopUp)
    setStatusPopUp(false);
  };

  useEffect(() => {
    // if (props?.postal?.outlet?.data[0]?.is_open && !checkIfRestDay(props?.postal?.outlet?.data[0]?.is_open)) {
    //   console.log(props?.postal?.outlet?.data[0])
    //   selectOutlet({ ...props.postal?.outlet?.data[0] })
    //   changeDeliveryCharge(props.postal?.outlet?.data[0])
    // }

    let numOfOut = 0 //RESET OUTLET NUMBER EVERYTIME OUTLET CHANGES
    let cdata = props?.outlets?.business_location;
    props.postal.outlet?.data?.forEach((outlet, index) => {
      if (outlet.is_open && !checkIfRestDay(outlet) && cdata[index]?.custom_field3 !== null) {
        numOfOut += 1
        setNumberOfOutlets(numOfOut)
      }
    })
  }, [props.postal.outlet]) //USED TO SEE IF USER HAS CHANGED HIS/HER ADDRESS. UPDATE THE DELIVERY CHARGE WITH THE NEW ONE BASED ON CURRENT SELECTED OUTLET

  const outletData = props?.postal?.outlet?.data || [];
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const todayDay = days[new Date().getDay()];

  const openOutlets = outletData?.filter((outlet) => {
    if (!outlet.is_open) return false;
    if (outlet?.custom_field3) {
      const isRestDay = outlet?.custom_field2?.includes(todayDay);
      if (isRestDay) return false;
    }
    return true;
  });

  const formatTime = (time) => {
    if (!time) return "";

    const [hourStr, minuteStr] = time.split(":");
    let hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);

    const postfix = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;

    return `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")} ${postfix}`;
  };

  const renderOutlets = () => {
    const outletData = props?.postal?.outlet?.data;

    // localStorage.setItem("amount_rounding_method",props?.getOutlates?.filter((outlet) => outlet.business_location.id === localStorage.getItem('location_id'))[0]?.amount_rounding_method || "none");

    const amount_rounding_method = props?.outlets?.business_location.filter((outlet) => outlet.id === parseInt(localStorage.getItem('location_id')))[0]?.amount_rounding_method || "none";

    localStorage.setItem("amount_rounding_method", amount_rounding_method);

    if (outletData) {
      const html = [];
      openOutlets?.length > 0 ?
        (outletData.map((outlet, index) => {
          if (outlet?.custom_field3) {
            const isOpen = outlet.is_open && !checkIfRestDay(outlet);
            html.push(
              <div
                key={index}
                className={`outlet-item-card ${currentOutlet.id === outlet.id ? "selected" : ""} ${!isOpen ? "disabled" : ""}`}
                style={!isOpen ? { pointerEvents: 'none', opacity: '0.6' } : {}}
                onClick={() => {
                  changeDeliveryCharge(outlet);
                  selectOutlet({
                    ...outlet,
                    id: outlet.id,
                    name: outlet.name
                  });
                }}
              >
                <div className="outlet-card-header">
                  <span className="outlet-name">{outlet.name}</span>
                  <span className={`status-badge ${isOpen ? "open" : "closed"}`}>
                    {isOpen ? 'Open' : 'Closed'}
                  </span>
                </div>

                <div className="outlet-body">
                  <div className="outlet-info-row">
                    <RiMapPin2Line />
                    <span>{outlet.address}</span>
                  </div>
                  <div className="outlet-info-row">
                    <RiTimeLine />
                    <span>{formatTime(outlet.open_time)} - {formatTime(outlet.close_time)}</span>
                  </div>
                  <div className="outlet-info-row highlight">
                    <RiPhoneLine />
                    <span>{outlet.phone}</span>
                  </div>
                </div>
              </div>
            )
          }
          return null;
        })) :
        html.push(
          <div className="ins no-outlets py-5">
            <RiStore2Line size={40} className="mb-3 opacity-30" />
            <p>Sorry, no stores are open right now.</p>
          </div>
        )
      return html
    }
  }

  return (
    <div>
      <Modal
        show={props.showOutlet}
        onHide={props.closeOutlet}
        className="premium-modal outlet-modal"
        dialogClassName="modal-md"
        centered
        backdrop="static"
      >
        <Modal.Header>
          <h4 className="modal-title">Select Outlet</h4>
          <ModalCloseButton
            onClick={props.closeOutlet}
            style={{ position: 'static', width: '32px', height: '32px' }}
          />
        </Modal.Header>

        <Modal.Body>
          {props.postal?.loading ? (
            <div className="d-flex justify-content-center align-items-center py-5">
              <Spinner animation="border" variant="danger" />
            </div>
          ) : outletData?.length > 0 ? (
            <>
              <div className="availability-header">
                <RiStore2Line />
                <span>{numberOfOutlets} Store(s) Available</span>
              </div>
              <div className="outlet-list">
                {props.postal.outlet ? renderOutlets() : ""}
              </div>
            </>
          ) : (
            <div className="text-center py-4 font-weight-bold ">
              Sorry, no outlets are available right now.
            </div>
          )}
        </Modal.Body>

        {!props.postal?.loading && outletData?.length > 0 && (
          <Modal.Footer className="border-0">
            <button
              type="button"
              className="btn lg primary d-block w-100"
              style={
                numberOfOutlets === 0 || currentOutlet.id === 0
                  ? { pointerEvents: "none", opacity: 0.5 }
                  : {}
              }
              onClick={() => {
                props.getStatusDeliveryStore({ location_id: currentOutlet.id });
                props.closeOutlet();
                props.showPickupDate();
              }}
            >
              Select Outlet
            </button>
          </Modal.Footer>
        )}
      </Modal>

      <Modal
        show={statusPopUp}
        onHide={hideStatusOutletModal}
        className="rounded-lg"
        dialogClassName="modal-md xs"
        contentClassName="pickup-modal xs modal_form status_delivery_modal"
        centered
        backdrop="static"
      >
        <Modal.Header>
          <h4 className="modal-title">Store Unavailable</h4>
          <ModalCloseButton
            onClick={hideStatusOutletModal}
            style={{ position: 'static', width: '32px', height: '32px' }}
          />
        </Modal.Header>
        <Modal.Body className="no">
          <div className="box data">
            <div className="ins">
              <span>This store is not available now.</span>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

const mapStateToProps = (state) => ({
  postal: state.postal,
  outlets: state.products.outlates,
  outlet_status: state.products.outlet_status
});
export default withTranslation()(
  connect(mapStateToProps, { getOutletInformation, getOutlates, getStatusDeliveryStore, getCurrentOutlet })(
    OutletInfo
  )
);